import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { CniFacilitiesTable } from "@/features/cni-facilities/components/CniFacilitiesTable"

const searchSchema = z.object({ id: z.string().optional() })

export const Route = createFileRoute("/_authed/cni/facilities")({
  component: CniFacilitiesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function CniFacilitiesPage() {
  const { t } = useTranslation("cni-facilities")
  const { id } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniFacilitiesTable initialSelectedId={id ?? null} />
    </div>
  )
}
